module.exports = __webpack_public_path__ + "static/img/vivo Pad3 Pro.d35ce154.png";